/**
 * Vtransaction_Entity type guard.
 *
 * @param {any} vtransactionJson Vtransaction object from API
 * @returns {boolean} Return true if type is Vtransaction_Entity
 */
function validator(
  vtransactionJson: unknown
): vtransactionJson is Vtransaction_Entity {
  if (typeof vtransactionJson === "object" && vtransactionJson != null) {
    Vtransaction_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(vtransactionJson).includes(element))
        throw new Error("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Vtransaction_Entity {
  static requiredFields = [
    "id",
    "talentID",
    "projectID",
    "amount",
    "createdAt",
    "updatedAt",
    "projectName",
  ];

  constructor(vtransactionJson: unknown) {
    if (validator(vtransactionJson)) {
      this.id = vtransactionJson.id;
      this.talentID = vtransactionJson.talentID;
      this.projectID = vtransactionJson.projectID;
      // Not required: servers without the column simply don't send it, and the
      // UI falls back to the old project-based ownership rule.
      this.jobID = vtransactionJson.jobID;
      this.amount = vtransactionJson.amount;
      this.notes = vtransactionJson.notes;
      this.createdAt = vtransactionJson.createdAt;
      this.updatedAt = vtransactionJson.updatedAt;
      this.projectName = vtransactionJson.projectName;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Vtransaction_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  talentID: number;
  projectID?: number;
  /** Job whose adjustment generated this row; 0 or absent is a manual entry. */
  jobID?: number;
  amount: number;
  notes: string;
  createdAt: string;
  updatedAt: string;
  projectName: string;
}
